// import '../assets/css/AboutHeroSection.css'
import Fade from 'react-reveal/Fade';
import FooterSection from './FooterSection'
import ContactHeroSection from './ContactHeroSection' 
// import Navbar from './NavBar.js'



function Contact() {
  return (
    <div className="AboutPage">
      <Fade left>
      <section className="ab1">
          <ContactHeroSection />
      </section>
      </Fade>
     <Fade right>
      <section className="ab2">
        <FooterSection />
      </section>
      </Fade>
        {/*
      <Fade left>
       <section className="ab3 exp">
        <ExpSection />
      </section>
      </Fade>
      <Fade right>
      <section className="ab4 skillset">
        <SkillsetSection />
      </section>
      </Fade>
      <Fade left>
      <section className="ab5">
        <FoooterTiles />
      </section>
      </Fade> */}
    </div>
  );
}

export default Contact;
